import { SLICE_NAME } from "../../model/types/types";

export const ActionType = {
  UPDATE_ALERT: `${SLICE_NAME}/update_alert`,
  RESET_ALERTS: `${SLICE_NAME}/reset_alerts`,
} as const;
